<script>
    import {link} from 'svelte-routing';
</script>
<footer id="colophon" class="site-footer">
    <div class="footer-image-wrapper">
        <div class="top-footer-container">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-lg-3">
                        <div class="widget footer-logo">
                            <ul class="footer-social">
                                <li>
                                    <a href="https://www.facebook.com/MangoMist-Resort-Bangalore-125966220801052/" target="_blank">
                                        <svg fill="#fff" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="32px" height="32px"><path d="M 25 3 C 12.861562 3 3 12.861562 3 25 C 3 36.019135 11.127533 45.138355 21.712891 46.728516 L 22.861328 46.902344 L 22.861328 29.566406 L 17.664062 29.566406 L 17.664062 26.046875 L 22.861328 26.046875 L 22.861328 21.373047 C 22.861328 18.494965 23.551973 16.599417 24.695312 15.410156 C 25.838652 14.220896 27.528004 13.621094 29.878906 13.621094 C 31.758714 13.621094 32.490022 13.734993 33.185547 13.820312 L 33.185547 16.701172 L 30.738281 16.701172 C 29.349697 16.701172 28.210449 17.475903 27.619141 18.507812 C 27.027832 19.539724 26.84375 20.771816 26.84375 22.027344 L 26.84375 26.044922 L 32.966797 26.044922 L 32.421875 29.564453 L 26.84375 29.564453 L 26.84375 46.929688 L 27.978516 46.775391 C 38.71434 45.319366 47 36.126845 47 25 C 47 12.861562 37.138438 3 25 3 z M 25 5 C 36.057562 5 45 13.942438 45 25 C 45 34.729791 38.035799 42.731796 28.84375 44.533203 L 28.84375 31.564453 L 34.136719 31.564453 L 35.298828 24.044922 L 28.84375 24.044922 L 28.84375 22.027344 C 28.84375 20.989871 29.033574 20.060293 29.353516 19.501953 C 29.673457 18.943614 29.981865 18.701172 30.738281 18.701172 L 35.185547 18.701172 L 35.185547 12.009766 L 34.318359 11.892578 C 33.718567 11.811418 32.349197 11.621094 29.878906 11.621094 C 27.175808 11.621094 24.855567 12.357448 23.253906 14.023438 C 21.652246 15.689426 20.861328 18.170128 20.861328 21.373047 L 20.861328 24.046875 L 15.664062 24.046875 L 15.664062 31.566406 L 20.861328 31.566406 L 20.861328 44.470703 C 11.816995 42.554813 5 34.624447 5 25 C 5 13.942438 13.942438 5 25 5 z"/></svg>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.tripadvisor.in/Hotel_Review-g297628-d2239682-Reviews-Mango_Mist_Resorts-Bengaluru_Karnataka.html" target="_blank">
                                      <svg fill="#fff" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="32px" height="32px">    <path d="M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z"/></svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="widget footer-logo">
                            <div class="textwidget">
                                <br />
                                <img class="img-responsive" src="/images/Mangomist-logo_165x165.png" alt="MangoMist Resort Bangalore" />
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-lg-3">
                        <div class="widget footer-1">
                            <h3>Contact Us</h3>
                            <div class="textwidget">
                                MANGO MIST RESORTS<br />
                                SY NO 33,37,HARAPANAHALLI<br />
                                ANEKAL BANNERGHATTA ROAD<br />
                                BENGALURU<br />
                                INDIA 560105<br />
                                P. 9060090777<br />
                                Mail: <a href="mailto:resort@mangomist.com">resort@mangomist.com</a><br />
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-lg-3">
                        <div class="widget footer-2">
                            <h3>Explore</h3>
                            <div class="menu-footer-container">
                                <ul id="menu-footer" class="menu">
                                    <li id="menu-item-3410" class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-3410"><a href="/" use:link>Home</a></li>
                                    <li id="menu-item-2722" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2722">
                                        <a target="_top" href="/careers" use:link>Careers</a>
                                    </li>
                                    <li id="menu-item-2608" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2608">
                                        <a target="_top" href="terms-and-conditions" use:link>Terms and Conditions</a>
                                    </li>
                                    <li id="menu-item-2607" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2607">
                                        <a target="_top" href="privacy-policy" use:link>Privacy Policy</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-lg-3">
                        <div class="widget footer-3"><div class="textwidget"></div></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <div class="row" style="padding: 35px 0px;">
                <div class="col-xs-12">
                    <div class="site-info">
                        Copyright 2017 ,Mangomist Resorts
                    </div>
                    <!-- .site-info -->
                </div>
            </div>
        </div>
    </div>
</footer>

<style>
    .site-footer {
        display: block;
        clear: both;
    }
</style>